import React, { useContext, useEffect } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './genericError.scss';
import { findParamFromUrl, removeUserSessionData } from 'common/utils/app.utils';
import appConfig from '../../../config/config';
import { AppContext } from 'App';

const GENERIC_ERROR = () => {
  const { showSteps } = useContext(AppContext);
  const partyId = findParamFromUrl('partyId', false);

  useEffect(() => {
    showSteps && showSteps(false);
    removeUserSessionData();
  }, []);
  return (
    <div className="failure_box">
      <div className="container">
        <div className="box_content">
          <div className="message_container">
            <h2 className="message_title"> Sorry! The link has expired.</h2>
            <p className="message_content">The link has expired.</p>
            <span className="description">
              Should you have any queries regarding cancellation or extension of service, write to us at
              <a href="mailto:enterprise.request@airtel.com" className="mail-url">
                {' '}
                enterprise.request@airtel.com
              </a>{' '}
              copying your Account Manager and Relationship Manager.
            </span>
            <div className="button_action">
              <a className="track-link" href={partyId ? appConfig.kamTrackLeadPage + '?partyId=' + partyId : appConfig.kamTrackLeadPage}>
                <Button displayName="Track Order" />
              </a>
              <a href={appConfig.aehdashboardUrl}>
                <Button displayName="Go Back To Home" variant="outlinebtn" buttonClass="outline-btn" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GENERIC_ERROR;
